import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import isEmpty from 'lodash/isEmpty';

import { fetchMostWantedNewReleases } from 'Redux/ducks/algolia-calls';
import ProductListCard from 'Components/Cards/ProductListCard';

export default function MostWantedNewReleasesContainer({
  listCardNameTag,
  loadedHits,
  hitsToDisplay,
}) {
  const [hits, setHits] = useState([]);

  useEffect(() => {
    const fetchHits = async () => {
      if (!isEmpty(loadedHits)) {
        setHits(loadedHits);
      } else {
        const mostWantedHits = await fetchMostWantedNewReleases();
        setHits(mostWantedHits);
      }
    };

    fetchHits();
  }, [loadedHits]);

  return (
    <div>
      <h2 className="mb-3 h3 metacritic-list-title">
        <FormattedMessage id="most-wanted-new-releases-list.title" defaultMessage="Wishlist Most Wanted" />
      </h2>
      <ol className="product-list-card-list">
        {hits && hits.slice(0, hitsToDisplay).map((hit, i) =>
          <ProductListCard
            showReleaseDate
            hit={hit}
            index={i}
            key={hit.objectID}
            listCardNameTag={listCardNameTag}
            listCardContainerTag="li"
          />,
        )}
        {isEmpty(hits) && [...Array(10).keys()].map(i =>
          <ProductListCard index={i} key={i} listCardContainerTag="li" />,
        )}
      </ol>
    </div>
  );
}

MostWantedNewReleasesContainer.propTypes = {
  listCardNameTag: PropTypes.string,
  loadedHits: PropTypes.arrayOf(PropTypes.object),
  hitsToDisplay: PropTypes.number,
};

MostWantedNewReleasesContainer.defaultProps = {
  listCardNameTag: 'div',
  loadedHits: [],
  hitsToDisplay: 10,
};
